module.exports = __webpack_public_path__ + "img/selected7-min.f07ac847.png";